import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";

import clsx from "clsx";

import loginStyles from "features/login-screen/login.styles";

const useStyles = makeStyles(loginStyles);

function DemoPanel() {
  const classes = useStyles();

  return (
    <aside className={classes.demoPanel}>
      <div className={classes.demoText}>
        <Typography variant="h4" className={classes.title}>
          Start exploring
        </Typography>
        <Typography
          variant="h4"
          gutterBottom
          className={clsx(classes.title, classes.bold)}
        >
          business intelligence
        </Typography>
        <Typography variant="h5" gutterBottom className={classes.subtitle}>
          See why over 8,500 users rely on FYIsoft for a faster financial close.
        </Typography>
        <Button variant="contained" className={classes.demoButton}>
          Request a demo
        </Button>
      </div>
    </aside>
  );
}

export default DemoPanel;
